import type { FormInstance } from 'antd';
import { Divider } from 'antd';

import type { IEditoEventForm } from 'app/typings/edito';

import { ActionContainer } from '../ActionContainer/ActionContainer';

import { ExperienceTypeForm } from './ExperienceTypeForm/ExperienceTypeForm';
import { SearchCriteriaForm } from './SearchCriteriaForm/SearchCriteriaForm';

type Props = {
  fieldName: string | number;
  form: FormInstance<IEditoEventForm>;
};

export const SearchRedirectionForm = ({ fieldName, form }: Props) => {
  return (
    <ActionContainer fieldName={fieldName}>
      <ExperienceTypeForm fieldName={fieldName} form={form} />
      <Divider />
      <SearchCriteriaForm fieldName={fieldName} form={form} />
    </ActionContainer>
  );
};
